import React, {CSSProperties} from 'react';
import {Card, Flex, Image, Statistic} from "antd";
import axios from "axios";
import {useQuery} from "react-query";
import {CalendarOutlined, GatewayOutlined, TeamOutlined} from "@ant-design/icons";
import {Label} from "../../commons/translations/Label";
import {LOGO_PNG} from "../../media";
import {Heading} from "../../commons/translations/Heading";
import {useTranslation} from "react-i18next";
import {launcherCard} from "../common/styles";
import DragonIcon from "../../commons/icons/DragonIcon";

type StatsDTO = {
    eventCount: number;
    tableSessionCount: number;
    playerReservationCount: number;
    gamesCount: number;
}

export const RpgLodgeStats: React.FC = () => {
    const {t} = useTranslation();
    const {data, isLoading, error} = useQuery<StatsDTO>({
        queryKey: ['stats'],
        queryFn: async () => {
            const response = await axios.get('/api/stats');
            return response.data;
        }
    });

    if (error) {
        return <div><Label trl="stats.errors.load" /></div>;
    }

    const internalStyle: CSSProperties = {
        ...launcherCard,
        margin: '2em',
        maxWidth: '120px',
    }

    return (
        <div style={{maxWidth: '100%', marginTop: '20px'}}>
            <Card style={launcherCard} title={<Flex justify={"center"}><Heading level={5} trl={'home.stats.title'}/></Flex>}>
                <Flex justify={"center"} align={"center"}>
                    <Image src={LOGO_PNG} alt={'logo'} preview={false} style={{maxHeight: '150px'}} />
                </Flex>
                <Flex justify={"center"} align={"center"}>
                    <Label trl={'home.stats.subtitle'} style={{textAlign: "center"}} />
                </Flex>
            </Card>
            <Flex justify={"center"}>
                <Flex wrap gap={"small"}>
                    <Card style={internalStyle}>
                        <Statistic
                            prefix={<CalendarOutlined/>}
                            title={t('stats.events')}
                            value={data?.eventCount}
                            loading={isLoading} />
                    </Card>
                    <Card style={internalStyle}>
                        <Statistic
                            prefix={<GatewayOutlined />}
                            title={t('stats.tables')}
                            value={data?.tableSessionCount}
                            loading={isLoading} />
                    </Card>
                    <Card style={internalStyle}>
                        <Statistic
                            prefix={<TeamOutlined />}
                            title={t('stats.players')}
                            value={data?.playerReservationCount}
                            loading={isLoading} />
                    </Card>
                    <Card style={internalStyle}>
                        <Statistic
                            prefix={<DragonIcon />}
                            title={t('stats.games')}
                            value={data?.gamesCount}
                            loading={isLoading} />
                    </Card>
                </Flex>
            </Flex>
        </div>
    );
};
